module.exports = __webpack_public_path__ + "static/media/admin.330f35a2.png";